import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

function RequireAuth({ children, redirectTo = "/" }) {
  let isAuthenticated = useSelector((store) => store.auth.isLoggedIn);
  return isAuthenticated ? children : <Navigate to={redirectTo} />;
}

export default RequireAuth;
